import { IStore, StoreContext } from "store";
import { DealBase, TaskCreate, TaskPreview } from "store/types";
import { useContextSelector } from "use-context-selector";

export const useTasksSelect = (): TaskPreview[] =>
  useContextSelector(StoreContext, (store: IStore) => store.taskManagment.tasks);

export const useCreateTaskSelect = (): TaskCreate =>
  useContextSelector(StoreContext, (store: IStore) => store.taskManagment.create);

export const useTaskDealsSelect = (): DealBase[] =>
  useContextSelector(StoreContext, (store: IStore) => store.taskManagment.deals);
